var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLevelLiveBatteryRepair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 44,
    viewBox: "0 0 162.837 146.172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 0.616,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ec3400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bf2a00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y2: 1,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4285",
    "data-name": "Group 4285",
    transform: "translate(-112.808 -84.076)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4277",
    "data-name": "Group 4277",
    transform: "translate(112.884 84.075)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_33",
    "data-name": "Union 33",
    d: "M2,98.375a2,2,0,0,1-2-2V11.538a2,2,0,0,1,2-2H127.435a2,2,0,0,1,2,2V96.376a2,2,0,0,1-2,2ZM85.4,7.24a1,1,0,0,1-1-1V1a1,1,0,0,1,1-1h23.97a1,1,0,0,1,1,1v5.24a1,1,0,0,1-1,1Zm-66.223,0a1,1,0,0,1-1-1V1a1,1,0,0,1,1-1h23.97a1,1,0,0,1,1,1v5.24a1,1,0,0,1-1,1Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3317",
    "data-name": "Group 3317",
    transform: "translate(23.766 28.883)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_90",
    "data-name": "Rectangle 90",
    width: 18.356,
    height: 3.671,
    transform: "translate(0 7.343)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_610",
    "data-name": "Group 610",
    transform: "translate(66.085 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_93",
    "data-name": "Rectangle 93",
    width: 3.671,
    height: 18.356,
    transform: "translate(7.343)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_94",
    "data-name": "Rectangle 94",
    width: 18.356,
    height: 3.671,
    transform: "translate(0 7.343)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6137",
    "data-name": "Path 6137",
    d: "M231.171,181.814l13.265-15.463-8.2-2.1,4.752-11.469-14.052,15.188,8.162,2.171Z",
    transform: "translate(-194.866 -131.773)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1974",
    "data-name": "Rectangle 1974",
    width: 130,
    height: 4,
    transform: "translate(-0.076 80.375)",
    fill: "#ebf1f6",
    opacity: 0
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1976",
    "data-name": "Rectangle 1976",
    width: 130,
    height: 3,
    transform: "translate(-0.076 17.375)",
    fill: "#ebf1f6"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1970",
    "data-name": "Rectangle 1970",
    width: 115,
    height: 8,
    rx: 4,
    transform: "translate(0 108.374)",
    fill: "#cf2e17"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1971",
    "data-name": "Rectangle 1971",
    width: 29.798,
    height: 8,
    transform: "translate(69 116.374) rotate(90)",
    fill: "#cf2e17"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4288",
    "data-name": "Group 4288",
    transform: "translate(-27 3.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6141",
    "data-name": "Path 6141",
    d: "M284.5,185.545a37.418,37.418,0,1,1-37.418-37.419A37.42,37.42,0,0,1,284.5,185.545",
    transform: "translate(-94.667 -90.171)",
    fill: "#ebf1f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6139",
    "data-name": "Path 6139",
    d: "M277.059,181.822a33.7,33.7,0,1,1-33.7-33.7,33.7,33.7,0,0,1,33.7,33.7",
    transform: "translate(-90.944 -86.448)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6140",
    "data-name": "Path 6140",
    d: "M270.214,179.937A28.736,28.736,0,1,1,241.478,151.2a28.736,28.736,0,0,1,28.736,28.736",
    transform: "translate(-89.06 -84.563)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4287",
    "data-name": "Group 4287",
    transform: "translate(-17.95 -33.122)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6142",
    "data-name": "Path 6142",
    d: "M231.171,181.814l13.265-15.463-8.2-2.1,4.752-11.469-14.052,15.188,8.162,2.171Z",
    transform: "translate(-126.074 -72.771)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4332",
    "data-name": "Group 4332",
    transform: "translate(33.95 28.123)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5978",
    "data-name": "Path 5978",
    d: "M236.239,166.392h7.986a2.568,2.568,0,0,1,2.676,1.519c.547,1.157,3.908,8.1,4.5,9.243a7.315,7.315,0,0,1,.913,3.708v8.147c0,1.642-.79,2.311-2.007,2.311h-2.858c-1.642,0-1.884-1.7-1.884-3.223s-1.157-1.945-2.432-1.945H229.854c-1.276,0-2.432.426-2.432,1.945s-.242,3.223-1.884,3.223H222.68c-1.216,0-2.007-.669-2.007-2.311v-8.147a7.315,7.315,0,0,1,.913-3.708c.59-1.139,3.952-8.086,4.5-9.243a2.568,2.568,0,0,1,2.676-1.519Z",
    transform: "translate(-100.197 -69.959)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5981",
    "data-name": "Path 5981",
    d: "M222.54,175.186s4.092.95,4.676,1.115.931-.11.8-.713-.347-1.279-.419-1.516-.421-.474-1.077-.584-2.942-.456-3.27-.494-.823-.073-1,.494-.511,1.479.292,1.7",
    transform: "translate(-99.369 -65.923)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5982",
    "data-name": "Path 5982",
    d: "M240.691,175.186s-4.092.95-4.676,1.115-.931-.11-.8-.713.347-1.279.419-1.516.421-.474,1.077-.584,2.942-.456,3.27-.494.823-.073,1,.494.511,1.479-.292,1.7",
    transform: "translate(-91.301 -65.923)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5983",
    "data-name": "Path 5983",
    d: "M234.03,167.647h9.112s1.911,3.833,2.339,4.775c.494,1.086.032,1.481-.692,1.481H224.547c-.724,0-1.186-.4-.692-1.481.427-.942,2.339-4.775,2.339-4.775Z",
    transform: "translate(-98.372 -69.189)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5984",
    "data-name": "Path 5984",
    d: "M229.72,171.87l8.722-10.167-5.392-1.382,3.124-7.541-9.239,9.986,5.366,1.428Z",
    transform: "translate(-96.358 -78.304)",
    fill: "url(#linear-gradient-2)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLevelLiveBatteryRepair);
export default __webpack_public_path__ + "static/media/icon_level_Live_Battery_Repair.c4173ff0f154a957f05aa7ba4854930c.svg";
export { ForwardRef as ReactComponent };